<template>
  <div class="my">
    <cheader></cheader>
    <mt-header title="个人资料" class="reftitle">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <div class="info-top">
      <div class="f1">
        <span>头像</span>
        <img class="fr rarrow" src="/static/img/user/center/rightArrow.png">
        <img class="fr user" src="/static/img/contract/signer.png">
      </div>
      <hr>
      <div class="f2">
        <span>姓名</span>
        <span class="fr namecolor">{{realName}}</span>
      </div>
      <hr>
      <div class="f3">
        <span>实名认证</span>
        <img class="fr rarrow" src="/static/img/user/center/rightArrow.png">
        <span class="fr statuscolor">{{status}}</span>
      </div>
    </div>
    <div class="info-mid">
      <span>重设签署密码</span>
      <img class="fr rarrow" src="/static/img/user/center/rightArrow.png">
    </div>
    <div class="info-bottom">
      <a>退出当前帐号</a>
    </div>
  </div>
</template>

<script>
import cheader from '@/components/header';
export default {
  data () {
    return {
      realName:'huhao',
      status:'status'
    }
  },
  methods: {
    
  },
  components:{
    cheader
  }
}
</script>
<style>
.my{
  height: 100%;
  background-color: #f0f0f0;
}
.my .reftitle{
  background-color: #1f74d8;
}
.info-top{
  padding: 0 10px;
  background-color: #ffffff;
  margin-top: 15px;
}
.info-top .namecolor{
  color:#c1c1c1;
}
.info-top .statuscolor{
  color:#7d7d7d;
}
.info-mid{
  background-color: #ffffff;
  margin-top: 15px;
  padding: 0 10px;
  height:60px;
  line-height: 60px;
}
.info-top .f1{
  height:90px;
  line-height: 90px;
}
.info-top .f2,.info-top .f3{
  height:60px;
  line-height: 60px;
}
.info-top .user{
  width:60px;
  margin:15px 15px 0 0;
}
.info-top .f1 .rarrow{
  margin:35px 0 0 0;
}
.info-mid .rarrow,.info-top .f3 .rarrow{
  margin-top: 21px;
  margin-left:20px;
}
.rarrow{
  width:11px;
}
.info-top span,.info-mid span{
  font-size: 1.2rem;
  color: #7d7d7d; 
}
.info-bottom{
  margin-top: 15px;
  height:60px;
  line-height: 60px;
  background-color: #ffffff;
  text-align: center;
}
.info-bottom a{
  font-size: 1.2rem;
  color: #9Dc9f2; 
}
</style>



// WEBPACK FOOTER //
// src/module/my/Myinfo.vue